<template>
    <Dialog v-model:visible="visible_" modal header="Возврат ордера" @hide="close"
        class="border-none" 
        :style="{ width: '28rem' }">
        <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
                <span class="text-xs font-medium">ID ордера</span>
                <span class="text-sm">{{ orderId }}</span>
            </div>
            <div class="flex flex-column gap-1">
                <span class="text-xs text-600">Будет выполнен возврат платежа по данному ордеру.</span>
            </div>
            <div class="flex justify-content-end gap-2 mt-2">
                <Button label="Вернуть платеж" size="small" severity="danger" :loading="loading" @click="refund" />
                <Button label="Отмена" size="small" severity="secondary" @click="close" />
            </div>
        </div>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'

export default {
    name: 'AdminOrderRefund',
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        orderId: {
            type: [Number, String],
            required: true
        }
    },
    emits: ['update:modelValue', 'refunded'],
    data() {
        return {
            visible_: false,
            loading: false,
        }
    },
    methods: {
        async refund() {
            if (!this.orderId) return
            this.loading = true
            try {
                const resp = await this.connect.RefundAdminOrder(this.orderId).then(res=>res)
                if (resp && resp.result) {
                    this.$toast.add({ severity: 'success', summary: 'Успех', detail: 'Платеж возвращен', life: 1500 })
                    this.$emit('refunded', { id: this.orderId, status: 'refunded' })
                    this.close()
                } else {
                    const message = (resp && resp.message) ? resp.message : 'Не удалось выполнить возврат'
                    this.$toast.add({ severity: 'warn', summary: 'Ошибка', detail: message, life: 2500 })
                }
            } catch (e) {
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка запроса', life: 1500 })
            } finally {
                this.loading = false
            }
        },
        close() {
            this.visible_ = false
            this.$emit('update:modelValue', false)
        }
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(v) {
                this.visible_ = v
            }
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    }
}
</script>
